var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M938.7,160H85.3C38.4,160,0,197.3,0,242.8v538.3C0,826.7,38.4,864,85.3,864h853.3         c46.9,0,85.3-37.3,85.3-82.8V242.8C1024,197.3,985.6,160,938.7,160z M878.4,242.8L512,598.4L145.7,242.8H878.4z M85.3,781.2         V301.4l366.3,355.6c33.3,32.4,87.3,32.4,120.7,0l366.3-355.6v479.8H85.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f76b02319b150d7d4c8a4c5f22d1e1bd.svg";
export { ForwardRef as ReactComponent };